import {Icon} from 'mc/lib';
import * as PropTypes from 'prop-types';
import React, {PureComponent} from 'react';
import {Label} from 'reactstrap';
import {StavVolani} from "@mc/poh";
import * as StavVolaniInfo from "../../api/StavVolaniInfo";
import classNames from 'classnames';
import './StavVolaniLabel.scss';

export default class StavVolaniLabel extends PureComponent {

    static propTypes = {
        value: PropTypes.oneOf(StavVolani.values),
    };

    render() {
        const {value} = this.props;
        const cls = classNames("stav-zadost", `stav-zadost-${value.toLowerCase()}`);
        return (
            <span className={cls}>
                <Icon className="mr-2" icon={StavVolaniInfo.getIcon(value)}/>
                <Label>{StavVolaniInfo.getCaption(value)}</Label>
            </span>
        );
    }

};
